import { Image, Info } from 'components';

export default function TargetMarginOfErrorInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Arrow just missing the target of a dart board" path="target-margin-of-error.png" title="Target Margin of Error" />
        <h5>Target Margin of Error</h5>
        <p>
            The <span className="fst-italic">Target Margin of Error</span> is how accurate you want the result of your experiment or survey to be.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> You are buying food for a very large event with 10,000 people and you want to know how many vegetarian meals you need without asking all 10,000 people. If you don&apos;t want to buy more than 500 extra vegetarian meals, then 500 out of 10,000 represents a <span className="fst-italic">Target Margin of Error</span> of 5%.
            <br/>
            <br/>
            If you need to be very accurate, choose a very small number such as 1% or less. Election Polls often have a 4% Margin of Error or more.
        </p>
    </Info>;

}